import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MapPin, X } from 'lucide-react';
export const ScrollButton = ({
  children,
  className,
  onClick
}: {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}) => {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('precio')?.scrollIntoView({
      behavior: 'smooth'
    });
    if (onClick) onClick();
  };
  return <button onClick={handleClick} className={className} data-id="element-221">
      {children}
    </button>;
};
export const Countdown = () => {
  const [timeLeft, setTimeLeft] = useState(23 * 3600 + 59 * 60 + 37);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  return <div className="flex items-center gap-2 text-3xl md:text-4xl font-serif font-bold text-brand-terracotta justify-center" data-id="element-222">
      <div className="bg-white px-3 py-2 rounded-lg shadow-sm border border-brand-sand min-w-[2.5ch] text-center" data-id="element-223">
        {hours.toString().padStart(2, '0')}
      </div>
      <span className="text-brand-charcoal" data-id="element-224">:</span>
      <div className="bg-white px-3 py-2 rounded-lg shadow-sm border border-brand-sand min-w-[2.5ch] text-center" data-id="element-225">
        {minutes.toString().padStart(2, '0')}
      </div>
      <span className="text-brand-charcoal" data-id="element-226">:</span>
      <div className="bg-white px-3 py-2 rounded-lg shadow-sm border border-brand-sand min-w-[2.5ch] text-center" data-id="element-227">
        {seconds.toString().padStart(2, '0')}
      </div>
    </div>;
};
const names = ['María P.', 'Lucía F.', 'Sofía G.', 'Martín R.', 'Federico A.', 'Carolina M.', 'Diego S.', 'Valentina T.', 'Florencia B.', 'Camila V.', 'Agustín C.', 'Matías L.', 'Julieta N.', 'Micaela D.', 'Gonzalo H.'];
const cities = ['Milano', 'Roma', 'Napoli', 'Torino', 'Firenze', 'Bologna', 'Genova', 'Palermo', 'Venezia', 'Verona', 'Bari', 'Catania', 'Padova', 'Trieste'];
export const PurchasePopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: '',
    time: 0
  });
  useEffect(() => {
    const showPopup = () => {
      setData({
        name: names[Math.floor(Math.random() * names.length)],
        city: cities[Math.floor(Math.random() * cities.length)],
        time: Math.floor(Math.random() * 45) + 1
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 6000);
    };
    const initialTimeout = setTimeout(showPopup, 5000);
    const interval = setInterval(() => {
      showPopup();
    }, 30000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-228">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-xl shadow-2xl border border-brand-sand p-4 max-w-xs md:max-w-sm flex gap-4 items-start" data-id="element-229">
          <div className="bg-brand-terracotta/10 p-2.5 rounded-full text-brand-terracotta flex-shrink-0" data-id="element-230">
            <MapPin size={20} data-id="element-231" />
          </div>
          <div className="flex-1 pt-0.5" data-id="element-232">
            <p className="text-sm text-brand-charcoal leading-snug" data-id="element-233">
              <span className="font-bold block text-base mb-0.5" data-id="element-234">
                {data.name}
              </span>
              di {data.city} ha appena acquistato PILATES 360 {data.time} minuti
              fa.
            </p>
          </div>
          <button onClick={() => setIsVisible(false)} className="text-gray-400 hover:text-gray-600 flex-shrink-0" data-id="element-235">
            <X size={16} data-id="element-236" />
          </button>
        </motion.div>}
    </AnimatePresence>;
};